import React, { useEffect, useState } from 'react';
import { MenuIcon, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/90 backdrop-blur-sm' : 'bg-transparent'}`} data-id="element-135">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-136">
        <Link to="/" className="text-2xl font-bold" data-id="element-137">
          IKHAN<span className="text-red-600" data-id="element-138">FX</span>
        </Link>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-139">
          <Link to="/" className={`text-sm transition-colors ${isActive('/') ? 'text-red-600' : 'hover:text-gray-300'}`} data-id="element-140">
            Home
          </Link>
          <Link to="/classes" className={`text-sm transition-colors ${isActive('/classes') ? 'text-red-600' : 'hover:text-gray-300'}`} data-id="element-141">
            Classes
          </Link>
          <Link to="/membership" className={`text-sm transition-colors ${isActive('/membership') ? 'text-red-600' : 'hover:text-gray-300'}`} data-id="element-142">
            Membership
          </Link>
          <Link to="/about" className={`text-sm transition-colors ${isActive('/about') ? 'text-red-600' : 'hover:text-gray-300'}`} data-id="element-143">
            About
          </Link>
          <Link to="/contact" className={`text-sm transition-colors ${isActive('/contact') ? 'text-red-600' : 'hover:text-gray-300'}`} data-id="element-144">
            Contact
          </Link>
          <Link to="/signup" className="bg-red-600 text-white px-4 py-2 rounded text-sm font-medium hover:bg-red-700 transition-colors" data-id="element-145">
            Sign Up
          </Link>
          <Link to="/login" className="border border-red-600 text-white px-4 py-2 rounded text-sm font-medium hover:bg-red-600/10 transition-colors" data-id="element-146">
            Log In
          </Link>
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-147">
          {isMenuOpen ? <X size={24} data-id="element-148" /> : <MenuIcon size={24} data-id="element-149" />}
        </button>
      </div>
      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-black absolute top-full left-0 w-full" data-id="element-150">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-151">
            <Link to="/" className={`text-sm py-2 transition-colors ${isActive('/') ? 'text-red-600' : 'hover:text-gray-300'}`} data-id="element-152">
              Home
            </Link>
            <Link to="/classes" className={`text-sm py-2 transition-colors ${isActive('/classes') ? 'text-red-600' : 'hover:text-gray-300'}`} data-id="element-153">
              Classes
            </Link>
            <Link to="/membership" className={`text-sm py-2 transition-colors ${isActive('/membership') ? 'text-red-600' : 'hover:text-gray-300'}`} data-id="element-154">
              Membership
            </Link>
            <Link to="/about" className={`text-sm py-2 transition-colors ${isActive('/about') ? 'text-red-600' : 'hover:text-gray-300'}`} data-id="element-155">
              About
            </Link>
            <Link to="/contact" className={`text-sm py-2 transition-colors ${isActive('/contact') ? 'text-red-600' : 'hover:text-gray-300'}`} data-id="element-156">
              Contact
            </Link>
            <Link to="/signup" className="bg-red-600 text-white px-4 py-2 rounded text-sm font-medium hover:bg-red-700 transition-colors w-full" data-id="element-157">
              Sign Up
            </Link>
            <Link to="/login" className="border border-red-600 px-4 py-2 rounded text-sm font-medium hover:bg-red-600/10 transition-colors w-full" data-id="element-158">
              Log In
            </Link>
          </div>
        </div>}
    </header>;
}